<template>
    <div class="login-wrap">
        <transition name="el-zoom-in-bottom">
            <div class="card" v-show="cardShow">
                <div class="card-left">
                    <img class="img" src="../../assets/img/leftlogin.png" alt="素材图片" />
                </div>
                <div class="card-right">
                    <h6>智慧城市监测系统</h6>
                    <h6 class="normal">登录</h6>
                    <form>
                        <div class="form-group">
                            <label for="username">用户名:</label>
                            <input type="text" id="username" v-model="param.phone" placeholder="请输入用户名" required />
                        </div>
                        <div class="form-group margintop">
                            <label for="password">密码:</label>
                            <input type="password" id="password" v-model="param.password" placeholder="请输入密码"
                                required />
                        </div>
                        <button type="submit" ref="login" class="btn btn-primary"
                            @click.prevent="submitForm">登录</button>
                    </form>
                </div>
            </div>
        </transition>

        <vue-particles color="#dddddd" :particleOpacity="0.7" :particlesNumber="70" shapeType="circle" :particleSize="4"
            linesColor="#409EFF" :linesWidth="1" :lineLinked="false" :lineOpacity="0.4" :linesDistance="150"
            :moveSpeed="2" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push"
            class="vueParticles">
        </vue-particles>
    </div>
</template>

<script>
import { login, Alogin, QueryCompanyUser, QueryCompanyInfo } from '../../api';
export default {
    data: function () {
        return {
            companyInfoArr: [],
            dialogVisible: false,
            param: {
                phone: '',
                password: ''
            },
            cardShow: false
            // rules: {
            //     phone: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
            //     password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
            // }
        };
    },
    activated() { },
    mounted() {
        // setInterval(async () => {
        //     const a = await Alogin(this.param);
        //     console.log(a);
        // }, 1000);
        this.cardShow = true;

        // console.log(this.addTwoNumbers([0, 1, 0, 2, 1, 0, 1, 3, 2, 1, 2, 1]));
    },
    created() { },
    methods: {
        // addTwoNumbers(height) {
        //     let rain = 0
        //     for (let i = 0; i < height.length; i++) {

        //         if (height[i] < height[i - 1] && height[i] < height[i + 1]) {
        //             let leftIndex = -1
        //             let leftNum = 0
        //             let rightIndex = -1
        //             let rightNum = 0
        //             left: for (let j = i - 1; j < i; j--) {

        //                 if (height[j] > height[j - 1] && height[j] > height[j + 1]) {
        //                     console.log(height[j], 'height[j]');

        //                     leftNum = height[j - 1] - height[j]
        //                     leftIndex = j
        //                 } else {
        //                     break left
        //                 }

        //             }
        //             right: for (let j = i + 1; j < i; j++) {
        //                 if (height[j] > height[j - 1] && height[j] > height[j + 1]) {
        //                     console.log(height[j], 'height[j---]');

        //                     rightNum = height[j + 1] - height[j]
        //                     rightIndex = j
        //                 } else {
        //                     break right
        //                 }

        //             }
        //             // console.log(rightNum, leftNum, 'leftNum');

        //             if (leftIndex > 0 && rightIndex > 0) {
        //                 rain += (rightIndex - leftIndex - 1) * (rightNum - leftNum)
        //             }
        //         }
        //     }

        //     return rain
        // },
        async submitForm() {
            const { data, code, token } = await login(this.param);
            localStorage.setItem('userinfo', JSON.stringify(data));

            if (code !== 200) {
                return;
            }

            // 查询绑定的企业信息
            const companyList = await QueryCompanyUser({ id: data.id });

            let companyInfoArr = [];
            // 查找企业详情
            for (let i = 0; i < companyList.data.length; i++) {
                let obj = {
                    companyId: companyList.data[i].companyId,
                    companyCreateTime: companyList.data[i].createTime,
                    companyUpdateTime: companyList.data[i].updateTime
                };
                let companyInfo = await QueryCompanyInfo({ id: companyList.data[i].companyId });
                console.log(companyInfo);
                obj.companyName = companyInfo.data.name;
                obj.companyRole = companyInfo.data.role;
                obj.logo = companyInfo.data.logo;
                companyInfoArr.push(obj);
            }

            if (companyInfoArr.length == 1) {
                // 只有一个企业 直接进入
                window.localStorage.setItem('companyInfo', JSON.stringify(companyInfoArr[0]));
                // 判断是否圣豆电子
                console.log(companyInfoArr[0]);
                if (companyInfoArr[0].companyId == 1) {
                    console.log('第一');
                    this.$router.push('/ANewMaxWeb');
                } else {
                    console.log('第二');
                    if (companyInfoArr[0].companyId == 2) {
                        this.$router.push({ path: 'ANewMaxWeb', query: { token: token, companyInfo: JSON.stringify(companyInfoArr[0]), userinfo: JSON.stringify(data) } });
                    } else {
                        this.$router.push('/ANewMaxWeb');

                    }
                }

                console.log('只有一个企业');
            } else {
                this.dialogVisible = true;
            }

            this.companyInfoArr = companyInfoArr;
            return;
        },
        // 选择企业进入
        chooseCompany(e) {
            window.localStorage.setItem('companyInfo', JSON.stringify(e));
            if (e.companyId == 1) {
                this.$router.push('/ANewMaxWeb');
            } else {
                this.$router.push('/ANewMaxWeb');
            }

            console.log(e);
        }
    }
};
</script>

<style scoped lang="less">
/* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
.card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    display: flex;

    width: 900px;
    height: 500px;
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -400px;
    margin-top: -250px;
    transition: all 0.5s;
}

.normal {
    font-size: 22px;
    border-left: 5px solid #007bff;
    padding-left: 6px;
}

.card-left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;

    .img {
        width: 500px;
        height: 500px;
    }
}

.card-right {
    padding: 32px;
    padding-left: 32px;
}

.card-right h6 {
    margin-bottom: 30px;
}

.form-group {
    margin-bottom: 16px;
    font-size: 20px;
}

.margintop {
    margin-top: 30px;
}

label {
    display: block;
    margin-bottom: 20px;
}

input[type='text'],
input[type='password'] {
    width: 100%;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: 16px;
}

button {
    display: block;
    width: 100%;
    margin-top: 30px;
    padding: 12px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

button:hover {
    background-color: #0069d9;
}

.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url(../../assets/img/maxwebImg/testIBgcmg.jpg);
    background-size: 100%;
}

.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 40px;
    color: #fff;
    font-weight: bold;
    letter-spacing: 2px;
    padding-top: 50px;
}

.el-input /deep/ .el-input__inner {
    background-color: transparent;
    border: 1px solid equa;
    height: 45px;
    color: #fff;
    font-size: 20px;
    border-radius: 50px;
    padding-left: 30px;
}

.el-input /deep/ .el-input__inner:focus {
    border: 1px solid aqua;
}

.ms-ftitle {
    font-size: 22px;
    color: #fff;
    font-weight: bold;
    letter-spacing: 2px;
    text-align: center;
    margin: 20px;
}

.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 410px;
    height: 512px;
    box-sizing: border-box;
    margin: -256px 0 0 -205px;
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.3);
    overflow: hidden;
}

.ms-content {
    padding: 30px 30px;
}

.login-btn div {
    width: 100%;
    height: 36px;
    line-height: 36px;
    margin-bottom: 10px;
    background-color: transparent;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 20px;
    text-indent: 20px;
    text-align: center;
    cursor: pointer;
    border: 1px solid aqua;
    transition: all 0.5s;
    margin-top: 50px;
    padding: 10px 0;
}

.login-btn div:hover {
    background-color: rgb(6, 102, 102);
}

.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #fff;
}

.chooseCompany:hover {
    cursor: pointer;
    color: #409eff;
}
</style>